module.exports = __webpack_public_path__ + "static/lego-mindstorms-ev3-laboratory-35148885df769ef514b431ef93528872.jpg";